<template>
	<div id="classicFooter">

		<ul>
			<!--<li>
				<a :href="$t('footer.genterms')" @click.prevent="openPDFFile('conditions')" download tabindex="0">{{$t('footer.genterms')}}</a>
			</li>-->
			<li v-if="$t('footer.privacy.link').length > 0">
				<!-- Link must be specified in translations files to appears -->
				<a :href="$t('footer.privacy.link')" target="_blank" rel="noopener" tabindex="0">{{$t('footer.privacy.label')}}</a>
			</li>
			<li v-if="$t('footer.cookies.link').length > 0">
				<!-- Link must be specified in translations files to appears -->
				<a :href="$t('footer.cookies.link')" target="_blank" rel="noopener" tabindex="0">{{$t('footer.cookies.label')}}</a>
			</li>
			<!-- Link must be dynamic following the language -->
			<li>CONTACT{{ $i18n.locale.slice(0,2) === 'fr'?' ':''}}: <a v-if="$i18n.locale === 'nl_BE' || $i18n.locale === 'nl_NL'" href="mailto:infolijn@promolife.be" tabindex="0">infolijn@promolife.be</a>
				<a v-if="$i18n.locale != 'nl_BE' && $i18n.locale != 'nl_NL'" href="mailto:infoligne@promolife.be" tabindex="0">infoligne@promolife.be</a>
			</li>

			<li><button @click="openGdprBanner">{{ $t('footer.showGDPR') }}</button></li>

		</ul>

	</div>
</template>

<!-- ================================================================================== -->

<script>
	import openPDF from "../mixins/openpdf";

	export default {
		name:"ClassicFooter",
		mixins: [openPDF],
		methods: {
			openGdprBanner(){
				this.$store.dispatch('setGdprVisible', true);
			},
		},
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>

</style>
